export default {
  list: async function (params = {}) {
    const auth_token = await sessionStorage.getItem("token");

    // Build query string from params
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ""
      ) {
        queryParams.append(key, params[key]);
      }
    });

    const queryString = queryParams.toString();
    const url = `${process.env.REACT_APP_API_BASE_URL}/catalog/employee${
      queryString ? `?${queryString}` : ""
    }`;

    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: auth_token,
      }),
    });

    const response = await fetch(request);
    const json = await response.json();
    return json;
  },
};
